import { render } from "./home_screen.vue?vue&type=template&id=37877146&scoped=true"
import script from "./home_screen.vue?vue&type=script&lang=js"
export * from "./home_screen.vue?vue&type=script&lang=js"

import "./home_screen.vue?vue&type=style&index=0&id=37877146&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37877146"]])

export default __exports__